import {
    API_PATCH_APPLICATION_ACCOUNT_FILE,
    API_PATCH_APPLICATION_ACCOUNT_FILE_SUCCESS
} from '@api/lendingAPI/LendingAPI.actions';
import { GoogleTagManager, tracking } from '@iwoca/frontend-tracking-library';
import { fork, put, select, take, call, takeLatest } from 'redux-saga/effects';

import { CHOOSE_DOCUMENT_TYPE } from './chooseDocumentType/ChooseDocumentType.actions';
import { DOCUMENT_UPLOADER } from './documentUploader/DocumentUploader.actions';
import {
    ADD_TO_DOCUMENT_PENDING_LIST,
    SHOW_UPLOAD_DOCUMENTS_MODAL,
    UPDATE_DOCUMENT_STATUS_ON_COMPLETED,
    UPDATE_DOCUMENT_STATUS_ON_ERROR,
    UPLOAD_DOCUMENT
} from './UploadDocumentsModal.actions';
import { serialiseDocument } from './UploadDocumentsModalHelper';
import { selectAPI, putAndWaitAllAPI } from '../../../api/API.sagas';
import { fetchSaveUploadedDocuments } from '../../../api/lendingAPI/LendingAPI';
import { CLOSE_MODAL, OPEN_MODAL } from '../../../iwModals/Modals.actions';

export const uploadDocumentsModalSagaWorkers = [
    fork(showUploadDocumentsModal),
    fork(uploadDocument),
    fork(trackUploadDocumentsModalWorker)
];

function* showUploadDocumentsModal() {
    yield takeLatest(SHOW_UPLOAD_DOCUMENTS_MODAL, function* (action) {
        const hasProvidedDocumentType = !!action.documentType;
        const { customer_state } = yield selectAPI();

        switch (true) {
            case hasProvidedDocumentType:
                yield put({
                    type: DOCUMENT_UPLOADER,
                    preventBackNavigation: action.preventBackNavigation,
                    documentType: action.documentType,
                    feedbackIds: action.feedbackIds,
                    applicationId: action.applicationId,
                    customer_state
                });
                break;
            default:
                yield put({ type: CHOOSE_DOCUMENT_TYPE, customer_state });
                break;
        }

        yield put({
            type: OPEN_MODAL,
            id: 'UploadDocumentsModal'
        });

        yield take(CLOSE_MODAL);
    });
}

function* uploadDocument() {
    yield takeLatest(UPLOAD_DOCUMENT, function* (action) {
        tracking.ampli.documentsUploaded({
            'Document type': action.documentType.value,
            is_replacement_doc:
                action.feedbackIds && action.feedbackIds.length > 0
        });

        const documents = action.documents;
        yield documents.map((document) =>
            call(uploadSingleFile, document, action)
        );
    });
}

function* trackUploadDocumentsModalWorker() {
    yield takeLatest(DOCUMENT_UPLOADER, function* (action) {
        const documentType = action?.documentType?.label;

        GoogleTagManager.trackModal({
            interaction: 'Open',
            modalName: `${documentType}UploaderModal`
        });

        yield take(CLOSE_MODAL);

        GoogleTagManager.trackModal({
            interaction: 'Close',
            modalName: `${documentType}UploaderModal`
        });
    });
}

function* handleDocumentUploadSuccess(response) {
    const successResponse = response[0];
    yield put({ type: UPDATE_DOCUMENT_STATUS_ON_COMPLETED, successResponse });
}

function* handleDocumentUploadError(response, document) {
    const errorCode = response[0].errors[0].code;
    const deserialisedErrorResponse = { errorCode, document };

    yield put({
        type: UPDATE_DOCUMENT_STATUS_ON_ERROR,
        deserialisedErrorResponse
    });
}

function* uploadSingleFile(document, action) {
    yield put({
        type: ADD_TO_DOCUMENT_PENDING_LIST,
        document: {
            name: document.name,
            type: action.documentType.value,
            pending: true
        }
    });

    const body = serialiseDocument(document, action.documentType.value);
    //TODO Parallel calls should go through the API sagas to serialise/deserialise
    const impersonatingStateKey = yield select(
        ({ history }) => history.impersonatingStateKey
    );

    const serialiseBody = { impersonatingStateKey, body };
    const response = yield call(fetchSaveUploadedDocuments, serialiseBody);

    yield handleResponse(response, document, action);
}

function* handleResponse(response, document, action) {
    if (response[0].data) {
        yield handleDocumentUploadSuccess(response);

        if (action.feedbackIds && action.feedbackIds.length > 0) {
            yield call(markFeedbackAsDone, action);
        }
    } else {
        yield handleDocumentUploadError(response, document);
    }
}

function* markFeedbackAsDone(action) {
    const actionRequests = action.feedbackIds.map((feedbackId) => ({
        type: API_PATCH_APPLICATION_ACCOUNT_FILE,
        applicationId: action.applicationId,
        feedbackId: feedbackId.toString(),
        body: {
            marked_as_done_by_customer: true
        }
    }));

    yield putAndWaitAllAPI(actionRequests);
    yield put({ type: API_PATCH_APPLICATION_ACCOUNT_FILE_SUCCESS });
}
